var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmartphoneRound = function SvgSmartphoneRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Smartphone Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-1573.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart-phone",
    transform: "translate(1573.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,2 C18.1045695,2 19,2.8954305 19,4 L19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 L7,2 Z M17,4 L7,4 L7,20 L17,20 L17,4 Z M12,17 C12.5522847,17 13,17.4477153 13,18 C13,18.5522847 12.5522847,19 12,19 C11.4477153,19 11,18.5522847 11,18 C11,17.4477153 11.4477153,17 12,17 Z",
    id: "Icons/24/Smartphone"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphoneRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "smartphone-round.335d55e63685d49c3d583a3445574640.svg";